import { CostProfileCostsHistory } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateCost(httpClient: HttpClient) {
  return (
    { uuid }: CostProfileCostsHistory[number],
    nextCost: CostProfileCostsHistory[number],
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/costProfileHistories/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        cost: nextCost.cost,
        startDate: nextCost.startDate,
      },
    });
}

export { updateCost };
